export const isTaskRemoved = (task) => Boolean(task?.removed_at);

export const isTaskAvailableToday = (task, today = new Date()) => {
  if (task.status === 'draft' || isTaskRemoved(task)) {
    return false;
  }
  const baseDateStr = task.scheduled_for || task.created_at;
  if (!baseDateStr) {
    return true;
  }
  const day = new Date(today);
  day.setHours(0, 0, 0, 0);
  const taskDate = new Date(baseDateStr);
  if (Number.isNaN(taskDate.getTime())) {
    return true;
  }
  taskDate.setHours(0, 0, 0, 0);
  return taskDate <= day;
};

export const filterTodayTasks = (tasks, today = new Date()) =>
  tasks.filter((task) => (
    !isTaskRemoved(task)
    && task.status !== 'draft'
    && task.status !== 'completed'
    && task.status !== 'cancelled'
    && isTaskAvailableToday(task, today)
  ));

export const filterUpcomingTasks = (tasks, today = new Date()) =>
  tasks.filter((task) => (
    !isTaskRemoved(task)
    && task.status !== 'draft'
    && task.status !== 'completed'
    && task.status !== 'cancelled'
    && !isTaskAvailableToday(task, today)
  ));

export const filterRemovedTasks = (tasks) =>
  tasks.filter((task) => isTaskRemoved(task));

export const isCompletedToday = (task, today = new Date()) => {
  if (task.status !== 'completed' || isTaskRemoved(task)) {
    return false;
  }
  const day = new Date(today);
  day.setHours(0, 0, 0, 0);
  const updated = new Date(task.updated_at || task.created_at);
  updated.setHours(0, 0, 0, 0);
  return updated.getTime() === day.getTime();
};
